import ActionSheetItem from '@omni/kit/components/KitActionSheetItem';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';

export default function EventMoreActionSheet({
  isManager,
  onDeleteEvent,
  onEditEvent,
  onShareEvent,
  onActionClick,
}: {
  isManager: boolean;
  onDeleteEvent: () => void;
  onEditEvent: () => void;
  onShareEvent: () => void;
  onActionClick?: () => void;
}): ReactElement | null {
  const { t } = useTranslation(['groups']);

  const handleActionPress = (action: () => void) => () => {
    onActionClick?.();
    action();
  };

  return (
    <>
      {isManager ? (
        <>
          <ActionSheetItem
            icon='edit'
            iconColor={Colors.N900}
            label={t('labelEditEvent')}
            onPress={handleActionPress(onEditEvent)}
          />
          <ActionSheetItem
            icon='share'
            iconColor={Colors.N900}
            label={t('labelShareToChat')}
            onPress={handleActionPress(onShareEvent)}
          />
          <ActionSheetItem
            icon='delete'
            iconColor={Colors.R500}
            label={t('labelDeleteEvent')}
            onPress={handleActionPress(onDeleteEvent)}
          />
        </>
      ) : null}
    </>
  );
}
//******************************************************************************
// Styles
//******************************************************************************
const styles = StyleSheet.create({});
